// extracted by mini-css-extract-plugin
export default {"component":"css_component__bim0b","option":"css_option__+EkQR"};